export const storeProducts = [
    {
        id: 1,
        title: "Котан",
        img: "img/product-1.png",
        price: 10,
        company: "Google",
        info: "Lorem idsfsd sdfiosdf isdofnsdi sdoifsdf",
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 2,
        title: "Лис",
        img: "img/product-2.png",
        price: 12,
        company: "Fox",
        info: "Lorem idsfsd sdfiosdf isdofnsdi sdoifsdf",
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 3,
        title: "Лиса",
        img: "img/product-3.png",
        price: 13,
        company: "Fox",
        info: "Lorem idsfsd sdfiosdf isdofnsdi sdoifsdf",
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 4,
        title: "Тигр",
        img: "img/product-4.png",
        price: 14,
        company: "Tiger",
        info: "Lorem idsfsd sdfiosdf isdofnsdi sdoifsdf",
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 5,
        title: "Котище",
        img: "img/product-5.png",
        price: 15,
        company: "Cat",
        info: "Кот котище",
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 6,
        title: "Ракунчик",
        img: "img/product-6.png",
        price: 16,
        company: "Raccoon",
        info: "Lorem idsfsd sdfiosdf isdofnsdi sdoifsdf",
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 7,
        title: "Гугенот",
        img: "img/product-7.png",
        price: 17,
        company: "Raccoon",
        info: "Lorem idsfsd sdfiosdf isdofnsdi sdoifsdf",
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 8,
        title: "Енот",
        img: "img/product-8.png",
        price: 18,
        company: "Raccoon",
        info: "Lorem idsfsd sdfiosdf isdofnsdi sdoifsdf",
        inCart: false,
        count: 0,
        total: 0
    },

];

export const detailProduct = {
    id: 1,
    title: "Котан",
    img: "img/product-1.png",
    price: 10,
    company: "Google",
    info: "Lorem idsfsd sdfiosdf isdofnsdi sdoifsdf detail product object FFFFFFF ddd",
    inCart: false,
    count: 0,
    total: 0
};